module.exports = __webpack_public_path__ + "img/myposition_fb_트렌트 알렉산더-아놀드.f0e14e4c.png";